<template>
  <div>
    <div v-show="!isLoading">
      <the-header />
      <slot />
      <the-footer />
    </div>
    <div v-show="isLoading">
      <div class="Zoom__loading_area" style="margin-top:20%">
        <div class="Loading__anime">
          <div />
        </div>
        <p class="Zoom__loading_tx">
          少々お待ち下さい･･･
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import TheHeader from '@/views/layouts/TheHeader'
import TheFooter from '@/views/layouts/TheFooter'
import { mapState } from 'vuex'

export default {
  name: 'DefaultLayout',
  components: {
    TheHeader, TheFooter
  },
  computed: {
    ...mapState({
      isLoading: state => state.loading.isLoading
    })
  },
  mounted() {
    this.setHeight()
  },
  methods: {
    setHeight() {
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
      document.title = 'MELON'
    }
  }
}
</script>
